import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { base64ToBlob } from '../../../../util/Util';
import { showErrorToast, showSuccessToast } from '../../../../util/Constant';
import PSModalpdf from '../PSModalPdf/PSModalPdf';
import PSGlobalLoading from '../../PSGlobalLoading';
import LifeInvestmentService from '../../../shared/services/LifeInvestmentService';
import PSIcon from '../../PSIcon';

import { STORAGE_TOKEN_COGNITO } from '../../../../util/Constant';

import './index.scss';

const PSPolicyOptions = ({ dataPolicy }) => {
  const history = useHistory();
  const location = useLocation();
  const policySelected = dataPolicy;
  const tokenPD = localStorage.getItem('idTokenPD');

  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('detalle');
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const dataCoverage = localStorage.getItem('dataCoverage') || null;

  const getPreviousMonthDates = () => {
    const today = new Date();

    const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

    const lastDayPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0);

    // const dayBeforeLast = new Date(lastDayPrevMonth);
    // dayBeforeLast.setDate(lastDayPrevMonth.getDate() - 1);

    const formatDate = (date) => date.toISOString().split('T')[0];

    return {
      endDate: formatDate(lastDayPrevMonth),
      startDate: formatDate(firstDayPrevMonth),
    };
  };

  const { endDate, startDate } = getPreviousMonthDates();

  const getCoverage = async () => {
    try {
      const payload = {
        nroPoliza: policySelected?.BasicInfo?.NroPoliza,
      };
      const responseCoverage = await LifeInvestmentService.getCoverage(
        payload
      );
      localStorage.setItem('dataCoverage', responseCoverage?.capitalFormateado);
    } catch (error) {
      console.error('Error al obtener covertura:', error);
    }
  };

  const goToPageBeneficiary = () => {
    if (policySelected?.Beneficiarios.length > 0) {
      history.push({
        pathname: `/intranet/product/vidaInversion/${policySelected?.BasicInfo?.NroPoliza}/beneficiaries`,
        state: location.state,
      });
    } else {
      showErrorToast('No se encontró beneficiarios');
    }
  };

  const getPolicy = async (type) => {
    try {

      const idTokenCognito = localStorage.getItem(STORAGE_TOKEN_COGNITO) || '';

      setIsLoading(true);

      const responsePolicy = await LifeInvestmentService.getDownloadPolicy(
        policySelected?.BasicInfo?.NroPoliza, idTokenCognito
      );

      const urlPolicy = URL.createObjectURL(responsePolicy);
      setPdfUrl(urlPolicy);

      setIsLoading(false);
      if (type === 'ver') {
        setShowModal(true);
      } else {
        const link = document.createElement('a');
        link.href = urlPolicy;
        link.download = `kit_poliza_${policySelected?.BasicInfo?.NroPoliza ?? ""}.pdf`;
        link.click();
        URL.revokeObjectURL(urlPolicy);

        showSuccessToast('La descarga se realizó con éxito.');
      }
    } catch (error) {
      showErrorToast('Error al descargar el documento.');
      setIsLoading(false);
    }
  };

  const downloadStatement = async (type) => {
    try {
      setIsLoading(true);

      const payload = {
        policyNumber: policySelected?.BasicInfo?.NroPoliza.toString(),
        dni: policySelected?.Contractor?.NumeroDocumento,
        endDate,
        jobId: null,
        startDate,
      };
      const responseStatement = await LifeInvestmentService.getDownloadStatement(payload);
      if (responseStatement.success) {
        const data = responseStatement.document;
        const blob = base64ToBlob(data.base64Content, data.contentType);
        const urlStatement = URL.createObjectURL(blob);
        setPdfUrl(urlStatement);
        setIsLoading(false);

        if (type === 'ver') {
          setShowModal(true);
        } else {
          const a = document.createElement('a');
          a.href = urlStatement;
          a.download = data.originalName;
          a.click();
          setTimeout(() => URL.revokeObjectURL(urlStatement), 1000);

          showSuccessToast('La descarga se realizó con éxito.');
        }
      } else {
        showErrorToast('El documento no se encuentra disponible.');
        setIsLoading(false);
      }
    } catch (error) {
      const message =
      error.response?.data?.message ||
      'Ocurrió un error inesperado';
      
      showErrorToast(message);

      setIsLoading(false);
    }
  };

  const getCertificate = async (type) => {
    
    const idTokenCognito = localStorage.getItem(STORAGE_TOKEN_COGNITO) || '';

    try {
      setIsLoading(true);

      const responseCertificate = await LifeInvestmentService.getDownloadCertificate(
        policySelected?.BasicInfo?.NroPoliza, idTokenCognito
      );
      const urlCertificate = URL.createObjectURL(responseCertificate);
      setPdfUrl(urlCertificate);
      setIsLoading(false);

      if (type === 'ver') {
        setShowModal(true);
      } else {
        const link = document.createElement('a');
        link.href = urlCertificate;
        link.download = 'Constancia_Asegurado.pdf';
        link.click();
        URL.revokeObjectURL(urlCertificate);

        showSuccessToast('La descarga se realizó con éxito.');
      }
    } catch (error) {
      showErrorToast('Error al descargar el documento.');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!dataCoverage) {
      getCoverage();
    }
  }, []);

  return (
    <div className="tabs-container">
      {isLoading && <PSGlobalLoading show={isLoading} />}
      <PSModalpdf show={showModal} onClose={() => setShowModal(false)} pdfUrl={pdfUrl} />
      <div className="tabs-container__header">
        <button
          type="button"
          className={`tab-button ${activeTab === 'detalle' ? 'active' : ''}`}
          onClick={() => setActiveTab('detalle')}
        >
          Detalle
        </button>
        <button
          type="button"
          className={`tab-button ${activeTab === 'cobertura' ? 'active' : ''}`}
          onClick={() => setActiveTab('cobertura')}
        >
          Cobertura
        </button>
      </div>

      <div className="tabs-container__content">
        {activeTab === 'detalle' && (
          <div className="tabs-container__content--detail">
            <div>
              <div className="detail-option">Contratante</div>
              <div>{policySelected?.BasicInfo?.Contratante}</div>
            </div>
            <div>
              <div className="detail-option">Vigencia</div>
              <div>
                {policySelected?.BasicInfo?.InicioVigencia} al{' '}
                {policySelected?.BasicInfo?.FinVigencia}
              </div>
            </div>
            <div>
              <div className="detail-option">Póliza N° {policySelected?.BasicInfo?.NroPoliza}</div>
              <div className="detail-link">
                <div className="detail-link--action" onClick={() => getPolicy('ver')}>
                  Ver
                </div>
                <div className="detail-link--action" onClick={() => getPolicy('descargar')}>
                  Descargar
                </div>
              </div>
            </div>
            <div>
              <div className="detail-option">Constancia de asegurado</div>
              <div className="detail-link">
                <div className="detail-link--action" onClick={() => getCertificate('ver')}>
                  Ver
                </div>
                <div className="detail-link--action" onClick={() => getCertificate('descargar')}>
                  Descargar
                </div>
              </div>
            </div>
            <div>
              <div className="detail-option">Beneficiarios</div>
              <div className="detail-link">
                <div className="detail-link--action" onClick={() => goToPageBeneficiary()}>
                  Ver
                </div>
              </div>
            </div>
            <div>
              <div className="detail-option">Estado de cuenta</div>
              <div className="detail-link">
                <div className="detail-link--action" onClick={() => downloadStatement('ver')}>
                  Ver
                </div>
                <div className="detail-link--action" onClick={() => downloadStatement('descargar')}>
                  Descargar
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'cobertura' && (
          <div className="tabs-container__content--coverage">
            <p>
              En caso de fallecimiento del asegurado, los beneficiarios designados recibirán además
              de la inversión realizada, el monto de:
            </p>
            <p className="highlight">{dataCoverage}</p>
            <div className="help-box">
              <div className="help-icon" aria-hidden="true">
                <PSIcon type="info" className="arrow" />
              </div>
              <div>
                <strong>¿Necesita ayuda? Contáctenos:</strong>
                <ul>
                  <li>Lima: 01-391-3000 / Provincias: 0801-1-1278</li>
                  <li>Mail: clientes@protectasecurity.pe</li>
                  <li>Dirección: Av. Domingo Orué N° 165, 8vo. Piso, Lima 34 - Perú</li>
                  <li>
                    Horario de atención: Lunes a Viernes de 9:00 am a 6:00 pm a excepción de
                    feriados.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PSPolicyOptions;
